import React from 'react';

/**
 * FrostedCardHeroLayout
 * Visual Design originating from the About Hero:
 * - Full-bleed background image with atmospheric darkening gradients
 * - Centered max-w-7xl responsive container
 * - Frosted glass content card (backdrop-blur, subtle inner highlights, deep shadow)
 */
export default function FrostedCardHeroLayout({
  id = 'hero',
  backgroundImage = '/home.webp',
  backgroundAlt = 'InnovHer Hero Background',
  badge,
  breadcrumbs,
  children,
  className = '',
}) {
  return (
    <section
      id={id}
      className={`relative min-h-[90vh] lg:min-h-screen flex flex-col justify-center pt-32 pb-20 lg:pt-36 lg:pb-28 bg-[#08080a] text-white overflow-hidden ${className}`}
    >
      {/* Background Architectural/Flagship Image */}
      {backgroundImage && (
        <img
          src={backgroundImage}
          alt={backgroundAlt}
          className="absolute inset-0 w-full h-full object-cover object-center select-none pointer-events-none opacity-40 lg:opacity-50"
        />
      )}

      {/* Atmospheric Overlays & Vignette */}
      <div className="absolute inset-0 bg-gradient-to-r from-black/85 via-black/60 to-black/70 pointer-events-none" />
      <div className="absolute inset-x-0 top-0 h-36 bg-gradient-to-b from-[#08080a] via-[#08080a]/70 to-transparent pointer-events-none" />
      <div className="absolute inset-x-0 bottom-0 h-44 bg-gradient-to-t from-[#08080a] via-[#08080a]/80 to-transparent pointer-events-none" />
      <div className="absolute top-1/3 -left-40 w-[600px] h-[600px] rounded-full bg-[#d42b92]/15 blur-[160px] pointer-events-none" />

      {/* Content Container aligned with page grid */}
      <div className="relative max-w-7xl mx-auto px-6 lg:px-8 w-full z-10">
        {/* Optional Breadcrumbs */}
        {breadcrumbs && (
          <div className="mb-6 sm:mb-8">
            {breadcrumbs}
          </div>
        )}

        {/* Optional Eyebrow / Badge */}
        {badge && (
          <div className="mb-6">
            {badge}
          </div>
        )}

        {/* Frosted Glass Content Card */}
        <div className="max-w-2xl lg:max-w-[720px] rounded-2xl sm:rounded-3xl bg-black/60 backdrop-blur-xl border border-white/10 p-6 sm:p-10 lg:p-12 shadow-[0_20px_60px_rgba(0,0,0,0.7),inset_0_1px_1px_rgba(255,255,255,0.12)] reveal-up">
          {children}
        </div>
      </div>
    </section>
  );
}
